import { render, staticRenderFns } from "./CategorySampleImage.vue?vue&type=template&id=ddee216a&scoped=true&"
import script from "./CategorySampleImage.vue?vue&type=script&lang=js&"
export * from "./CategorySampleImage.vue?vue&type=script&lang=js&"
import style0 from "./CategorySampleImage.vue?vue&type=style&index=0&id=ddee216a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddee216a",
  null
  
)

export default component.exports